export default "__VITE_ASSET__BC6jGF7x__"